import { render, staticRenderFns } from "./UsersTasksHandler.vue?vue&type=template&id=2b6544dd&scoped=true&"
import script from "./UsersTasksHandler.vue?vue&type=script&lang=js&"
export * from "./UsersTasksHandler.vue?vue&type=script&lang=js&"
import style0 from "./UsersTasksHandler.vue?vue&type=style&index=0&id=2b6544dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6544dd",
  null
  
)

export default component.exports